/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { PlatformModule } from '@angular/cdk/platform';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';


import { PhxSliderHandleComponent } from './phx-handle.component';
import { PhxSliderMarksComponent } from './phx-marks.component';
import { PhxSliderComponent } from './phx-slider.component';
import { PhxSliderStepComponent } from './phx-step.component';
import { PhxSliderTrackComponent } from './phx-track.component';
import { PhxTooltipModule } from '../tooltip/phx-tooltip.module';

@NgModule({
  exports: [
    PhxSliderComponent,
    PhxSliderTrackComponent,
    PhxSliderHandleComponent,
    PhxSliderStepComponent,
    PhxSliderMarksComponent
  ],
  declarations: [
    PhxSliderComponent,
    PhxSliderTrackComponent,
    PhxSliderHandleComponent,
    PhxSliderStepComponent,
    PhxSliderMarksComponent
  ],
  imports: [CommonModule, PlatformModule, PhxTooltipModule]
})
export class PhxSliderModule {}
